const config = {
  SSO_CLIENT_ID: "03330-indahdev-l3n",
  // BASE_API_URL: "http://localhost:8020",
  // BASE_API_URL_DEV: "https://localhost:8020",
  // BACKEND API (existing)
  BASE_API_URL: "https://indah-api.bps.go.id",
  BASE_API_URL_DEV: "https://indah-api-dev.bps.go.id",
  // BACKEND API (Metadata Statistik - untuk recycle data mskeg/msvar/msind)
  // BASE_API_URL_MMS: "https://mms-api.bps.go.id/v2/metadata-statistik",
  // BASE_API_URL: "http://localhost:8020",
  GEOSERVER_API_URL: "https://indah-map.bps.go.id",
}

export default config

